import { contrastRatio, isHexColor } from "./contrast";

/** Minimum contrast of the employer's accent against every color it meets (WCAG 2.2 AA text). */
export const minimumTenantAccentContrast = 4.5;

/**
 * Colors of the light theme the accent meets, by their token in `global.css`: the text on primary
 * buttons, links on cards and on the page, and the accent surface. They are the colors the server
 * checks (`TenantBranding.LightSurfaces` plus white text); `themeContrast.test.ts` checks that they
 * match `global.css`.
 */
export const tenantAccentBackdrops = {
  "--color-accent-contrast": "#ffffff",
  "--color-surface": "#ffffff",
  "--color-bg": "#f6f7f9",
  "--color-accent-surface": "#dce9f8",
} as const satisfies Readonly<Record<string, string>>;

/**
 * Checks whether the accent color of the employer (T-108) is readable on every light surface it
 * meets. An accent that is not, for example one stored before the surfaces changed, falls back to
 * the brand accent (T-159).
 *
 * @param color - The accent color of the employer.
 * @returns `true` if the color has the form `#rrggbb` and reaches 4.5:1 against every backdrop.
 */
export function isReadableTenantAccent(color: string): boolean {
  const readable =
    isHexColor(color) &&
    Object.values(tenantAccentBackdrops).every(
      (backdrop) => contrastRatio(color, backdrop) >= minimumTenantAccentContrast,
    );

  return readable;
}
